/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AelNavigationParams } from '@gh/builder-shared';
import { AelEvents, getAelEventsArray, ScheduleType } from '@gh/builder-shared-data';
import { HelpID } from '@gh/common-shared';

import { AbstractScheduleDetailsComponent } from '../abstract-schedule-details.component';
import { ScheduleDetailsCommandService } from '../schedule-details-command.service';
import { ScheduleDetailsFormState } from '../schedule-details-form.service';

@Component({
  standalone: false,
  selector: 'gh-pre-main-schedule-details',
  templateUrl: 'pre-main-schedule-details.component.html',
  providers: [ScheduleDetailsFormState, ScheduleDetailsCommandService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreMainScheduleDetailsComponent extends AbstractScheduleDetailsComponent {
  get helpId(): HelpID {
    return {
      [ScheduleType.PreConstruction]: 'schedules/pre-constructions/details',
      [ScheduleType.Maintenance]: 'schedules/warranty/details',
    }[this.form.type];
  }

  get baseRoutePath(): string {
    return {
      [ScheduleType.PreConstruction]: 'schedules/pre-construction',
      [ScheduleType.Maintenance]: 'schedules/maintenance',
    }[this.form.type];
  }

  get pageTitle(): string {
    return {
      [ScheduleType.PreConstruction]: 'lbl_pre_construction_sch',
      [ScheduleType.Maintenance]: 'lbl_maintenance_sch',
    }[this.form.type];
  }

  get parentTitle(): string {
    return {
      [ScheduleType.PreConstruction]: 'lbl_pre_construction_schedules',
      [ScheduleType.Maintenance]: 'lbl_maintenance_schedules',
    }[this.form.type];
  }

  get titlePrefix(): string {
    return {
      [ScheduleType.PreConstruction]: 'lbl_pre_construction_sch_for_job',
      [ScheduleType.Maintenance]: 'lbl_maintenance_sch_for_job',
    }[this.form.type];
  }

  constructor(public form: ScheduleDetailsFormState,
              commands: ScheduleDetailsCommandService) {
    super(commands);
  }

  buildAelNavigationParams(): AelNavigationParams {
    return {
      [ScheduleType.PreConstruction]: {
        label: 'lbl_pre_construction_sch',
        entityType: 'JOB',
        entityId: this.form.jobId,
        eventTypeIds: getAelEventsArray(AelEvents.Job.PreConstructionSchedule),
      },
      [ScheduleType.Maintenance]: {
        label: 'lbl_maintenance_sch',
        entityType: 'JOB',
        entityId: this.form.jobId,
        eventTypeIds: getAelEventsArray(AelEvents.Job.MaintenanceSchedule),
      },
    }[this.form.type];
  }
}
